
import { CharismaApi } from "../CharismaApi.js";

export const CharismaStudentTrainingApi = {
 
    ListTrainings: async function(pStudentId : number){
        const lResponse = await CharismaApi.request({
            url:`/studentTrainings/listTrainings.php`,
            method:"GET",
            params:{
                studentId:pStudentId
            }
        })
        return lResponse.data;
    },

    ListStudentsForTutor: async function(pTutorId : number){
        const lResponse = await CharismaApi.request({
            url:`/studentTrainings/listStudentsForTutor.php`,
            method:"GET",
            params:{
                tutorId:pTutorId
            }
        })
        return lResponse.data;
    },

    ListStudents: async function(pTrainingId : number){

        const lResponse = await CharismaApi.request({
            url:`/studentTrainings/listStudentsTraining.php`,
            method:"GET",
            params:{
                trainingId: pTrainingId
            }
        })
        return lResponse.data;
    },
    ListTrashedStudents: async function(pTrainingId : number){

        const lResponse = await CharismaApi.request({
            url:`/studentTrainings/listTrashedStudents.php`,
            method:"GET",
            params:{
                trainingId: pTrainingId
            }
        })
        return lResponse.data;
    },
    GetStudentTraining: async function(pStudentTrainingId : number){

        const lResponse = await CharismaApi.request({
            url:`/studentTrainings/getStudentTraining.php`,
            method:"GET",
            params:{
                studentTrainingId : pStudentTrainingId
            }
        })
        return lResponse.data;
    },
    ListPeriodEvals: async function(pStartDate : string, pEndDate : string, pStudentTrainingId){

        const lResponse = await CharismaApi.request({
            url:`/studentTrainings/listPeriodEvals.php`,
            method:"GET",
            params:{
                startDate : pStartDate,
                endDate : pEndDate,
                studentTrainingId:pStudentTrainingId
            }
        })
        return lResponse.data;
    },
    DeletePeriodEvals: async function(pStartDate : string, pEndDate : string, pStudentTrainingId, pExams : number[], pAssessments : number[]){
        const lDatas = new FormData();

        lDatas.append('studentTrainingId', pStudentTrainingId);
        lDatas.append('startDate', pStartDate);
        lDatas.append('endDate', pEndDate);
        pAssessments.forEach((lId)=>{
            lDatas.append("assessmentIds[]", lId);    
        });
        pExams.forEach((lId)=>{
            lDatas.append("examIds[]", lId);    
        });
        const lResponse = await CharismaApi.request({
            url:`/studentTrainings/deletePeriodEvals.php`,
            method:"POST",
            data:lDatas
        })
        return lResponse.data;
    },    
    CreateStudentTraining: async function(pStudentId:number, pCourseId: number, pTutorId: number, pTrainingId : number, pFinancalId : number, pStartDate : string, pEndDate : string){
        const lDatas = new FormData();
        lDatas.append('studentId', pStudentId);
        lDatas.append('courseId', pCourseId);
        lDatas.append('tutorId', pTutorId);
        lDatas.append('trainingId', pTrainingId);
        lDatas.append('financalId', pFinancalId);
        lDatas.append('startDate', pStartDate);
        lDatas.append('endDate', pEndDate);
        const lResponse = await CharismaApi.request({
            url:`/studentTrainings/createStudentTraining.php`,
            method:"POST",
            data:lDatas
        })
        return lResponse.data;
    },

    UpdateStudentTraining: async function(pTutorId: number, pCourseId:number, pFinancalId:number, pStartDate:string, pEndDate : string, pReason : number, pId:number){
        const lDatas = new FormData();
        lDatas.append('studentTrainingId', pId);
        lDatas.append('courseId', pCourseId);
        lDatas.append('tutorId', pTutorId);
        lDatas.append('financalId', pFinancalId);
        lDatas.append('startDate', pStartDate);
        lDatas.append('endDate', pEndDate);
        lDatas.append('reason', pReason);
        const lResponse = await CharismaApi.request({
            url:`/studentTrainings/updateStudentTraining.php`,
            method:"POST",
            data:lDatas
        })
        return lResponse.data;
    },    
    DeleteStudentTrainings: async function(pId : number []){
        const lDatas = new FormData();
        pIds.forEach((lId)=>{
            lDatas.append("studentTrainingIds[]", lId);    
        });
        const lResponse = await CharismaApi.request({
            url:`/studentTrainings/deleteStudentTraining.php`,
            method:"POST",
            data:lDatas
        })
        return lResponse.data;
    },
    TrashStudentTraining: async function(pId : number){
        const lDatas = new FormData();
        lDatas.append("studentTrainingId", pId);    
        const lResponse = await CharismaApi.request({
            url:`/studentTrainings/trashStudentTraining.php`,
            method:"POST",
            data:lDatas
        })
        return lResponse.data;
    },    
    RestoreStudentTrainings: async function(pId : number){
        const lDatas = new FormData();
        lDatas.append("studentTrainingId", lId);    
        const lResponse = await CharismaApi.request({
            url:`/studentTrainings/restoreStudentTraining.php`,
            method:"POST",
            data:lDatas
        })
        return lResponse.data;
    },    
    AddDocument: async function(pStudentTrainingId : number, pStudentId : number,  pDocument : File, pType : string, pDocType : string, pTrainingId:number){
        const lDatas = new FormData();
        lDatas.append('studentTrainingId', pStudentTrainingId);
        lDatas.append('studentId', pStudentId);
        lDatas.append('trainingId', pTrainingId);
        lDatas.append('file', pDocument);
        lDatas.append('type', pType);
        lDatas.append('docType', pDocType);
        const lResponse = await CharismaApi.request({
            url:`/studentTrainings/addDocument.php`,
            method:"POST",
            data:lDatas
        })
        return lResponse.data;
    },
    UpdateAccepted: async function(pStudentTrainingId:number, pTrainingId: number, pStudentId: number, signature){
        const lDatas = new FormData();
        lDatas.append("studentTrainingId", pStudentTrainingId);
        lDatas.append("trainingId", pTrainingId);
        lDatas.append("studentId", pStudentId);
        if (signature){
            lDatas.append("signature", signature);
        }
        const lResponse = await CharismaApi.request({
            url:`/studentTrainings/updateDocumentAccepted.php`,
            method:"POST",
            data:lDatas
        })
        return lResponse.data;
    },    
    UpdateValidity: async function(pDocumentId:number, pValid : number, pStudentTrainingId:number, $pStudentId : number, $pTrainingId: number){
        const lDatas = new FormData();
        lDatas.append("documentId", pDocumentId);
        lDatas.append("studentTrainingId", pStudentTrainingId);
        lDatas.append("valid", pValid)
        lDatas.append("studentId", $pStudentId)
        lDatas.append("trainingId", $pTrainingId)
        const lResponse = await CharismaApi.request({
            url:`/studentTrainings/updateDocumentValidity.php`,
            method:"POST",
            data:lDatas
        })
        return lResponse.data;
    },
    SendSubscribeReminder: async function(pStudentId:number, pTrainingId : number, pStudentTrainingId : number){
        const lDatas = new FormData();
        lDatas.append("studentId", pStudentId);
        lDatas.append("trainingId", pTrainingId);
        lDatas.append("studentTrainingId", pStudentTrainingId)
        const lResponse = await CharismaApi.request({
            url:`/studentTrainings/sendSubscribeReminder.php`,
            method:"POST",
            data:lDatas
        })
        return lResponse.data;  
    },
    ListDocument: async function(pStudentTraining:number, pType:string){
        const lResponse = await CharismaApi.request({
            url:`/studentTrainings/listDocuments.php`,
            method:"GET",
            params:{
                studentTrainingId:pStudentTraining,
                type: pType
            }
        })
        return lResponse.data;
    }, 
    DeleteDocuments: async function(pIds : number[]){
        const lDatas = new FormData();
        pIds.forEach((lId)=>{
            lDatas.append("documentIds[]", lId);    
        });
        const lResponse = await CharismaApi.request({
            url:`/studentTrainings/deleteDocuments.php`,
            method:"POST",
            data:lDatas
        })
        return lResponse.data;
    },
    CreateAlert: async function(pSubject: string, pAlert : string, pStudentTrainingId:number){
        const lDatas = new FormData();
        lDatas.append("subject", pSubject);
        lDatas.append("alert", pAlert);
        lDatas.append("studentTrainingId", pStudentTrainingId)
        const lResponse = await CharismaApi.request({
            url:`/studentTrainings/createAlert.php`,
            method:"POST",
            data:lDatas
        })
        return lResponse.data;          
    },
    ListAlerts: async function(pStudentTraining:number){
        const lResponse = await CharismaApi.request({
            url:`/studentTrainings/listAlerts.php`,
            method:"GET",
            params:{
                studentTrainingId:pStudentTraining
            }
        })
        return lResponse.data;
    },  
    DeleteAlerts: async function(pIds : number[]){
        const lDatas = new FormData();
        pIds.forEach((lId)=>{
            lDatas.append("alertIds[]", lId);    
        });
        const lResponse = await CharismaApi.request({
            url:`/studentTrainings/deleteAlerts.php`,
            method:"POST",
            data:lDatas
        })
        return lResponse.data;
    },
    UpdateAbsence: async function(pSubject: string, pFromDate : string, pToDate : string, pId: number){
        const lDatas = new FormData();
        lDatas.append("subject", pSubject);
        lDatas.append("fromDate", pFromDate);
        lDatas.append("toDate", pToDate);
        lDatas.append("absenceId", pId)
        const lResponse = await CharismaApi.request({
            url:`/studentTrainings/updateAbsence.php`,
            method:"POST",
            data:lDatas
        })
        return lResponse.data;          
    },    
    CreateAbsence: async function(pSubject: string, pFromDate : string, pToDate : string, pStudentId: number, pStudentTrainingId:number){
        const lDatas = new FormData();
        lDatas.append("subject", pSubject);
        lDatas.append("fromDate", pFromDate);
        lDatas.append("toDate", pToDate);
        lDatas.append("studentTrainingId", pStudentTrainingId);
        lDatas.append("studentId", pStudentId);
        const lResponse = await CharismaApi.request({
            url:`/studentTrainings/createAbsence.php`,
            method:"POST",
            data:lDatas
        })
        return lResponse.data;          
    },
    ListAbsences: async function(pStudentTraining:number){
        const lResponse = await CharismaApi.request({
            url:`/studentTrainings/listAbsences.php`,
            method:"GET",
            params:{
                studentTrainingId:pStudentTraining
            }
        })
        return lResponse.data;
    },  
    DeleteAbsences: async function(pIds : number[]){
        const lDatas = new FormData();
        pIds.forEach((lId)=>{
            lDatas.append("absenceIds[]", lId);    
        });
        const lResponse = await CharismaApi.request({
            url:`/studentTrainings/deleteAbsences.php`,
            method:"POST",
            data:lDatas
        })
        return lResponse.data;
    },    
    JustifyAbsence: async function(pJustified : number, pAbsenceId: number){
        const lDatas = new FormData();
        lDatas.append('justified', pJustified);
        lDatas.append('absenceId', pAbsenceId);
        const lResponse = await CharismaApi.request({
            url:`/studentTrainings/justifyAbsence.php`,
            method:"POST",
            data:lDatas
        })
        return lResponse.data;
    },   
    AddAbsenceDoc: async function(pStudentId : number, pStudentTrainingId: number,pFile : File, pAssessmentId: number){
        const lDatas = new FormData();
        lDatas.append('studentId', pStudentId);
        lDatas.append('studentTrainingId', pStudentTrainingId);
        lDatas.append('absenceId', pAssessmentId);
        lDatas.append('file', pFile);
        const lResponse = await CharismaApi.request({
            url:`/studentTrainings/addAbsenceDoc.php`,
            method:"POST",
            data:lDatas
        })
        return lResponse.data;
    },     
    DeleteAbsenceDoc: async function(pStudentId : number, pStudentTrainingId: number, pAssessmentId: number){
        const lDatas = new FormData();
        lDatas.append('studentId', pStudentId);
        lDatas.append('studentTrainingId', pStudentTrainingId);
        lDatas.append('absenceId', pAssessmentId);      
        const lResponse = await CharismaApi.request({
            url:`/studentTrainings/deleteAbsenceDoc.php`,
            method:"POST",
            data:lDatas
        })
        return lResponse.data;
    },     
    UpdateLate: async function(pSubject: string, pDate : string, pHour : string, pId: number){
        const lDatas = new FormData();
        lDatas.append("subject", pSubject);
        lDatas.append("lateDate", pDate);
        lDatas.append("lateHour", pHour);
        lDatas.append("lateId", pId)
        const lResponse = await CharismaApi.request({
            url:`/studentTrainings/updateLate.php`,
            method:"POST",
            data:lDatas
        })
        return lResponse.data;          
    },    
    CreateLate: async function(pSubject: string, pDate : string, pHour : string, pStudentId: number, pStudentTrainingId:number, pType: number){
        const lDatas = new FormData();
        lDatas.append("subject", pSubject);
        lDatas.append("lateDate", pDate);
        lDatas.append("lateHour", pHour);
        lDatas.append("studentTrainingId", pStudentTrainingId);
        lDatas.append("studentId", pStudentId);
        lDatas.append("type", pType);
        const lResponse = await CharismaApi.request({
            url:`/studentTrainings/createLate.php`,
            method:"POST",
            data:lDatas
        })
        return lResponse.data;          
    },
    ListLates: async function(pStudentTraining:number, pType: number){
        const lResponse = await CharismaApi.request({
            url:`/studentTrainings/listLates.php`,
            method:"GET",
            params:{
                type:pType,
                studentTrainingId:pStudentTraining
            }
        })
        return lResponse.data;
    },  
    DeleteLates: async function(pIds : number[], pType: number){
        const lDatas = new FormData();
        pIds.forEach((lId)=>{
            lDatas.append("lateIds[]", lId);    
        });
        lDatas.append("type", pType)
        const lResponse = await CharismaApi.request({
            url:`/studentTrainings/deleteLates.php`,
            method:"POST",
            data:lDatas
        })
        return lResponse.data;
    },    
    JustifyLate: async function(pJustified : number, pLateId: number){
        const lDatas = new FormData();
        lDatas.append('justified', pJustified);
        lDatas.append('lateId', pLateId);
        const lResponse = await CharismaApi.request({
            url:`/studentTrainings/justifyLate.php`,
            method:"POST",
            data:lDatas
        })
        return lResponse.data;
    },   
    AddLateDoc: async function(pStudentId : number, pStudentTrainingId: number,pFile : File, pLateId: number){
        const lDatas = new FormData();
        lDatas.append('studentId', pStudentId);
        lDatas.append('studentTrainingId', pStudentTrainingId);
        lDatas.append('lateId', pLateId);
        lDatas.append('file', pFile);
        const lResponse = await CharismaApi.request({
            url:`/studentTrainings/addLateDoc.php`,
            method:"POST",
            data:lDatas
        })
        return lResponse.data;
    },     
    DeleteLateDoc: async function(pStudentId : number, pStudentTrainingId: number, pLateId: number){
        const lDatas = new FormData();
        lDatas.append('studentId', pStudentId);
        lDatas.append('studentTrainingId', pStudentTrainingId);
        lDatas.append('lateId', pLateId);      
        const lResponse = await CharismaApi.request({
            url:`/studentTrainings/deleteLateDoc.php`,
            method:"POST",
            data:lDatas
        })
        return lResponse.data;
    },           
    DownloadZip: async function(pStudentTrainingId : number, pStudentId : number, pType : string, pStudentName : string){
        const lDatas = new FormData();
        lDatas.append("studentTrainingId", pStudentTrainingId);
        lDatas.append("studentId", pStudentId);
        lDatas.append("type", pType);
        lDatas.append("studentName", pStudentName);
        const lResponse = await CharismaApi.request({
            url:`/studentTrainings/downloadDocuments.php`,
            method:"POST",
            data:lDatas
        })
        return lResponse.data;
    },
    ImportStudents: async function(pFile : File, pTrainingId : number){
        const lDatas = new FormData();
        lDatas.append('file', pFile);
        lDatas.append('trainingId', pTrainingId);
        const lResponse = await CharismaApi.request({
            url:`/studentTrainings/import.php`,
            method:"POST",
            data:lDatas
        })
        return lResponse.data;
    },     
    CreateStudentCertification: async function(pItemId: number, pDate : string,  pValidation: number, pRetake: number, pStudentTrainingId:number){
        const lDatas = new FormData();
        lDatas.append("itemId", pItemId);
        lDatas.append("date", pDate);
        lDatas.append("validation", pValidation);
        lDatas.append("studentTrainingId", pStudentTrainingId);
        lDatas.append("retake", pRetake);
        const lResponse = await CharismaApi.request({
            url:`/studentTrainings/createStudentCertification.php`,
            method:"POST",
            data:lDatas
        })
        return lResponse.data;          
    },
    UpdateStudentCertification: async function(pId: number, pItemId: number, pDate : string,  pValidation: number, pRetake: number, pStudentTrainingId: number){
        const lDatas = new FormData();
        lDatas.append("itemId", pItemId);
        lDatas.append("date", pDate);
        lDatas.append("validation", pValidation);
        lDatas.append("certificationId", pId);
        lDatas.append("retake", pRetake);
        lDatas.append("studentTrainingId", pStudentTrainingId);
        const lResponse = await CharismaApi.request({
            url:`/studentTrainings/updateStudentCertification.php`,
            method:"POST",
            data:lDatas
        })
        return lResponse.data;          
    },    
    ListStudentCertifications: async function(pStudentTraining:number){
        const lResponse = await CharismaApi.request({
            url:`/studentTrainings/listStudentCertifications.php`,
            method:"GET",
            params:{
                studentTrainingId:pStudentTraining
            }
        })
        return lResponse.data;
    },  
    GetStudentCertification: async function(pId:number){
        const lResponse = await CharismaApi.request({
            url:`/studentTrainings/getStudentCertification.php`,
            method:"GET",
            params:{
                certificationId:pId
            }
        })
        return lResponse.data;
    },      
    DeleteStudentCertifications: async function(pIds : number[]){
        const lDatas = new FormData();
        pIds.forEach((lId)=>{
            lDatas.append("certificationIds[]", lId);    
        });
        const lResponse = await CharismaApi.request({
            url:`/studentTrainings/deleteStudentCertifications.php`,
            method:"POST",
            data:lDatas
        })
        return lResponse.data;
    },      
}